export default __webpack_public_path__ + "static/media/view.74ddfe11.svg";